import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
// import Tools from '../../tools';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies, useCookies } from 'react-cookie';
// import Enums from '../../enums'

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargePayment(props) {
    const formRef = React.createRef();
    const [formData, setFormData] = useState(null);
    const [oid, setOid] = useState(props.oid);
    const [cookies, setCookie, removeCookie] = useCookies(['point']);
    const [isGetFormData, setIsGetFormData] = useState(false);

    useEffect(() => {
        if (oid != null
            && false == isGetFormData
        ) {
            getOnlinePayData();
            setIsGetFormData(true);
        }
    }, [oid]);

    function getOnlinePayData() {
        console.log(oid);
        let succRedirectUrl = "https://nezcdev.dataa.com.tw/back/order/v1/PaymentRedirect?return="
            + encodeURIComponent(props.return_url);
        console.log(succRedirectUrl);

        let tmpData = {
            oid: oid,
            return_url: succRedirectUrl, //when finish payment
            client_back_url: succRedirectUrl//when click back
        }
        //--------- API not working ----------
        API.OrderOnlinePayment(tmpData).
            then((data) => {
                console.log(data);
                if (data.URL
                    && data.Method
                    && data.MerchantID
                    && data.TradeInfo
                    && data.TradeSha
                    && data.Version) {
                    setFormData(data);
                } else {
                    if (data.msg) alert(data.msg);
                    else alert("server error");
                    console.log(data);
                }
            });
    }

    function onClickOnlinePay() {
        //trigger form click
        console.log(formRef);
        formRef.current.submit();
    }

    function onClickPointPay() {
        let tmpData = {
            oid: oid
        }
        //--------- API not working ----------
        API.OrderPlatformPointPayment(tmpData).
            then((data) => {
                console.log(data);
                // {msg: "點數交易成功", platform_point: 21895, code: "22050"}
                // if (data) {
                if (22050 == data.code) {
                    //succ
                    //update platform_point
                    setCookie("point", data.platform_point);
                    alert("問卷已上架")
                    props.onFinishPointPayment();
                } else if (null != data.msg) {
                    alert(data.msg)
                }

                //     // {
                //     //     formula_text: "(題目數 5 * 樣本數 5 * 性別控樣係數 1.50 * 年齡控樣係數 1.30 * 地區控樣係數 2.00 = 97)"
                //     //     oid: "ORD210824233618"
                //     //     platform_point: 97
                //     //     price: 582
                //     // }
                //     setOrder({ ...data })
                //     setSubStep(2);
                // } else {
                //     alert("Server error");
                // }
            });
    }

    function render() {
        let paymentForm = null;
        if (formData) {
            paymentForm = (
                <form name='newebpay' action={formData.URL} method="POST" ref={formRef}>
                    <input type="text" name="MerchantID" value={formData.MerchantID} hidden />
                    <input type="text" name="TradeInfo" value={formData.TradeInfo} hidden />
                    <input type="text" name="TradeSha" value={formData.TradeSha} hidden />
                    <input type="text" name="Version" value={formData.Version} hidden />
                    <Button variant="danger" type="submit" hidden>線上結帳</Button>
                </form>
            )
        }

        return (
            <Container className="App mb-50">
                <Card>
                    <Card.Body>
                        <Row>
                            {props.content}
                            <Col xs={4} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickOnlinePay}>線上結帳</Button></Col>
                            {props.disablePoint ? null : <Col xs={4} style={{ display: "flex", flexDirection: "column-reverse" }}><Button variant="danger" onClick={onClickPointPay}>使用點數</Button></Col>}
                        </Row>
                        {paymentForm}
                        {/* <Row>
                            <Col className="col text-left">
                                <Button onClick={onTest}>開始使用手機測試</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mt-4 col text-center">
                                <Button variant="danger" onClick={onShelf}>{isSending ? "上架中, 請稍候.." : "確定問卷上架"}</Button>
                            </Col>
                        </Row> */}
                    </Card.Body>
                </Card>
            </Container >
        );
    }
    return render();
})